<template>
	<b-container fluid class="w-100 px-3" @mouseup="endDragging()">
		<Spinner v-if="loadingStatus" text="Retrieving data..." classes="text-dark-8 mh-60" spinner-color="var(--c-dark-8)"
			spinner-size="15px" />
		<b-row v-else id="resizible-wrapper" tag="main" class="flex-md-nowrap  position-relative mt-5 pt-2">
			<aside class="d-block overflow-md-visible overflow-hidden">
				<div class="d-flex align-items-center mt-0 mt-md-3 mb-3 pr-4 pr-md-0">
					<a href="/app/transcoder" class="btn btn-md btn-link-7 d-block">
						<svg width="6" height="12" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
							<path d="M7 13L1 7L7 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
								stroke-linejoin="round"></path>
						</svg>
					</a>

					<h1 v-if="transcoder" ref="title" class="text-md-s-xxll text-s-xxl text-500 title rounded"
						:class="{ 'title-editable': allowEditTitle }" :contenteditable="allowEditTitle" @click="editTranscoderName"
						@blur="saveNewTranscoderName" @keyup.enter="saveNewTranscoderName" v-text="transcoder.name" />
				</div>

				<StreamPreviewPane v-if="transcoder" :stream="transcoderWrapp" class="pr-0 pb-4 pb-md-0 pr-md-3 pl-0 pl-md-3 mt-8 aside-secondary aside-secondary--transcoder"
					ref="sidebarStreamPreviewPane" :stream-alive="streamAlive" :media-pulse="mediaPulse" :transcoderView="true"
					@toggle-transcoder="onTranscoderToggle" @delete-transcoder="onTranscoderDelete"
					@stream-updated="onTranscoderUpdate"/>

			</aside>

			<b-col class="container-mw container-mw_mobile-100 mr-auto pl-xl-3 pl-xxl-5 mt-2 mt-md-3"
				:style="{ width: `${100 - dividerPosition}%`, 'flex-basis': `${100 - dividerPosition}%` }">
				<div class="heading-transcoder--settings">
					<div class="d-flex mb-1">
						<h2 class="page-title mb-1 mb-md-0 mr-2">Transcoder Settings</h2>
					</div>
					<div class="d-flex align-items-center mb-2">
						<a class="text-dark-8 text-s-ss text-500 mb-3 inline-flex items-center"
							href="https://docs.castr.com/en/articles/8702304-how-to-transcode-your-stream" target="_blank">
							<svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
								<path fill-rule="evenodd" clip-rule="evenodd"
									d="M1.4999 1.8999C1.16853 1.8999 0.899902 2.16853 0.899902 2.4999V12.4999C0.899902 12.8313 1.16853 13.0999 1.4999 13.0999H5.7499C6.66117 13.0999 7.3999 13.8386 7.3999 14.7499V14.9999C7.3999 15.3313 7.66853 15.5999 7.9999 15.5999C8.04132 15.5999 8.08176 15.5957 8.12082 15.5877C8.39423 15.5318 8.5999 15.2899 8.5999 14.9999V14.7499C8.5999 13.8386 9.33863 13.0999 10.2499 13.0999H14.4999C14.8313 13.0999 15.0999 12.8313 15.0999 12.4999V2.4999C15.0999 2.16853 14.8313 1.8999 14.4999 1.8999H10.4999C9.47379 1.8999 8.56413 2.39844 7.9999 3.16652C7.43568 2.39844 6.52601 1.8999 5.4999 1.8999H1.4999ZM8.5999 4.9999L8.5999 12.4258C9.06554 12.0947 9.63498 11.8999 10.2499 11.8999H13.8999V3.0999H10.4999C9.45056 3.0999 8.5999 3.95056 8.5999 4.9999ZM7.3999 4.9999C7.3999 3.95056 6.54924 3.0999 5.4999 3.0999H2.0999V11.8999H5.7499C6.36483 11.8999 6.93426 12.0947 7.3999 12.4258V4.9999Z"
									fill="#ADB8DC" fill-opacity="0.5" />
							</svg>
							How Transcoder works
						</a>

						<a class="text-dark-8 text-s-ss text-500 mb-3 inline-flex items-center ml-4" v-b-modal.modal-demo-video>
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M6.98597 3.65906L10.6171 5.62591C12.3187 6.54763 13.1695 7.0085 13.3161 7.68016C13.3621 7.89091 13.3621 8.10909 13.3161 8.31984C13.1695 8.9915 12.3187 9.45237 10.6171 10.3741L6.98597 12.3409C5.41916 13.1896 4.63576 13.614 4.01328 13.4004C3.81704 13.3331 3.6369 13.2258 3.48425 13.0853C3 12.6397 3 11.7487 3 9.96685V6.03315C3 4.25126 3 3.36032 3.48425 2.91468C3.6369 2.77419 3.81704 2.6669 4.01328 2.59958C4.63576 2.38604 5.41916 2.81038 6.98597 3.65906Z"
									stroke="#68759C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
							Watch a tutorial
						</a>
					</div>
				</div>
				<b-row>
					<b-col lg="8">
						<b-alert v-if="hasLiveSubscription && !hasLiveSubscription.enabled || !hasLiveSubscription" variant="danger"
							show class="d-flex align-items-start">
							<svg class="mr-2 flex-shrink-0" width="16" height="16" viewBox="0 0 16 16" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd"
									d="M4.57328 3.12854C5.18596 2.51587 5.38162 2.33522 5.61326 2.23928C5.8449 2.14333 6.11099 2.13271 6.97745 2.13271L9.02131 2.13271C9.88776 2.13271 10.1538 2.14333 10.3855 2.23928C10.6171 2.33522 10.8128 2.51587 11.4255 3.12854L12.8707 4.57377C13.4834 5.18645 13.664 5.38211 13.76 5.61375C13.8559 5.84539 13.8665 6.11148 13.8665 6.97793V9.0218C13.8665 9.88825 13.8559 10.1543 13.76 10.386C13.664 10.6176 13.4834 10.8133 12.8707 11.426L11.4255 12.8712C10.8128 13.4839 10.6171 13.6645 10.3855 13.7605C10.1538 13.8564 9.88776 13.867 9.02131 13.867L6.97744 13.867C6.11099 13.867 5.8449 13.8564 5.61326 13.7605C5.38162 13.6645 5.18596 13.4839 4.57328 12.8712L3.12806 11.426C2.51538 10.8133 2.33474 10.6176 2.23879 10.386C2.14284 10.1543 2.13222 9.88825 2.13222 9.02179L2.13222 6.97793C2.13222 6.11148 2.14284 5.84539 2.23879 5.61375C2.33474 5.38211 2.51538 5.18645 3.12806 4.57377L4.57328 3.12854ZM5.15404 1.13062C4.67417 1.32939 4.30427 1.69977 3.80006 2.20465L3.72476 2.28002L2.27953 3.72524L2.20416 3.80054C1.69929 4.30476 1.3289 4.67466 1.13013 5.15453C0.931362 5.6344 0.931706 6.15786 0.932173 6.8714L0.93222 6.97793V9.02179L0.932173 9.12833C0.931706 9.84186 0.931362 10.3653 1.13013 10.8452C1.3289 11.3251 1.69929 11.695 2.20417 12.1992L2.27953 12.2745L3.72476 13.7197L3.80005 13.7951C4.30427 14.3 4.67417 14.6703 5.15404 14.8691C5.63392 15.0679 6.15738 15.0675 6.87092 15.0671L6.97744 15.067H9.0213L9.12785 15.0671C9.84138 15.0675 10.3648 15.0679 10.8447 14.8691C11.3246 14.6703 11.6945 14.3 12.1987 13.7951L12.274 13.7197L13.7192 12.2745L13.7946 12.1992L13.7946 12.1992C14.2995 11.695 14.6698 11.3251 14.8686 10.8452C15.0674 10.3653 15.067 9.84187 15.0666 9.12834V9.12832L15.0665 9.0218V6.97793L15.0666 6.8714C15.067 6.15786 15.0674 5.6344 14.8686 5.15453C14.6698 4.67466 14.2995 4.30476 13.7946 3.80054L13.7192 3.72524L12.274 2.28002L12.1987 2.20465L12.1987 2.20464C11.6945 1.69977 11.3246 1.32939 10.8447 1.13062C10.3648 0.931851 9.84138 0.932194 9.12784 0.932662L9.02131 0.932708H6.97745L6.87091 0.932662C6.15737 0.932194 5.63392 0.931851 5.15404 1.13062ZM6.67465 5.82559C6.44034 5.59127 6.06044 5.59126 5.82612 5.82557C5.5918 6.05987 5.59178 6.43977 5.82609 6.67409L7.15175 7.99984L5.82609 9.32559C5.59178 9.55992 5.5918 9.93982 5.82612 10.1741C6.06044 10.4084 6.44034 10.4084 6.67465 10.1741L8.00028 8.84837L9.32612 10.1741C9.56044 10.4084 9.94034 10.4084 10.1746 10.1741C10.409 9.93977 10.4089 9.55987 10.1746 9.32557L8.8488 7.99984L10.1746 6.67412C10.4089 6.43982 10.409 6.05992 10.1746 5.82559C9.94034 5.59127 9.56044 5.59126 9.32612 5.82557L8.00028 7.15132L6.67465 5.82559Z"
									fill="white" />
							</svg>
							<p class="text-s-s mb-0">Your plan has ended. Please <a class="text-underline text-reset" target="_blank"
									href="/app/subscribe">upgrade</a> to continue.</p>
						</b-alert>
					</b-col>
				</b-row>
				<b-row>
					<b-col lg="12" class="col-xl-6 mb-3">
						<div class="bg-dark-2 transcoder-settings-container overflow-hidden" style="width: 100%; height: 100%;">
							<div class="d-flex justify-content-between align-items-center mb-2">
								<label class="text-s-l text-light-2 text-500 flex items-center" id="video-info-tooltip">
									Video
									<svg class="ml-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd"
											d="M7.9999 2.10039C4.74142 2.10039 2.0999 4.74191 2.0999 8.00039C2.0999 11.2589 4.74142 13.9004 7.9999 13.9004C11.2584 13.9004 13.8999 11.2589 13.8999 8.00039C13.8999 4.74191 11.2584 2.10039 7.9999 2.10039ZM0.899902 8.00039C0.899902 4.07917 4.07868 0.900391 7.9999 0.900391C11.9211 0.900391 15.0999 4.07917 15.0999 8.00039C15.0999 11.9216 11.9211 15.1004 7.9999 15.1004C4.07868 15.1004 0.899902 11.9216 0.899902 8.00039ZM8.99988 5.5004C8.99988 6.05268 8.55216 6.5004 7.99988 6.5004C7.44759 6.5004 6.99988 6.05268 6.99988 5.5004C6.99988 4.94811 7.44759 4.5004 7.99988 4.5004C8.55216 4.5004 8.99988 4.94811 8.99988 5.5004ZM8.59988 8.5004C8.59988 8.16903 8.33125 7.9004 7.99988 7.9004C7.66851 7.9004 7.39988 8.16903 7.39988 8.5004V11.0004C7.39988 11.3318 7.66851 11.6004 7.99988 11.6004C8.33125 11.6004 8.59988 11.3318 8.59988 11.0004V8.5004Z"
											fill="#8794B5" />
									</svg>
								</label>

								<b-tooltip target="video-info-tooltip" placement="top">
									<div style="text-align: start; padding-right: 20px;">
										<label class="text-s-l color-light text-500 mb-0" style="color: white;">
											Codecs
										</label>
										<br>
										<span>H264 - H265</span>

										<br><br>
										<label class="text-s-l color-light text-500 mb-0" style="color: white;">
											Resolution
										</label>
										<br>
										<span>Max Width: 1920</span><br>
										<span>Max Height: 1080</span>

										<br><br>

										<span>Min Width: 320</span><br>
										<span>Min Height: 240</span>

										<br><br>
										<label class="text-s-l color-light text-500 mb-0" style="color: white;">
											Video Bitrate
										</label>
										<br>
										<span>Max Value: 15000</span><br>
										<span>Min Value: 250</span>
									</div>
								</b-tooltip>


								<div class="d-flex justify-content-between align-items-center">
									<b-form-checkbox v-model="copyVideo" size="sm" class="mb-md-0" switch>
									</b-form-checkbox>
									<label class="text-s-xs text-dark-7 text-500 mt-1">Copy from input</label>
								</div>

							</div>

							<div v-if="!copyVideo"
								class="d-flex justify-content-between align-items-center text-dark-6 mb-2 mt-4 mt-md-0">
								<h6 class="text-dark-8 text-s-s text-500 m-0">Codec</h6>
							</div>
							<div v-if="!copyVideo" class="d-flex align-items-center w-100 mb-4">
								<b-dropdown variant="dark-3" size="md" class="mr-2 propdown-filter w-100"
									toggle-class="d-flex align-items-center justify-content-between font-weight-normal"
									menu-class="dropdown-menu_md w-100">
									<template #button-content>
										<span>
											<span class="codec-name">{{ selectedCodec ? selectedCodec : 'Select an option' }}</span>
										</span>
									</template>
									<b-dropdown-item v-for="(codec, idx) in codecs" :key="idx" @click="onCodecSelect(codec)">
										<div class="selected a region-dropdown-item">
											<span class="codec-name">{{ codec.name }}</span>
										</div>
									</b-dropdown-item>
								</b-dropdown>
							</div>

							<div v-if="!copyVideo"
								class="d-flex justify-content-between align-items-center text-dark-6 mb-2 mt-4 mt-md-0">
								<h6 class="text-dark-8 text-s-s text-500 m-0">Resolution</h6>
							</div>
							<div v-if="!copyVideo" class="d-flex align-items-center w-100 justify-content-between">
								<b-form-group v-slot="{ ariaDescribedby }">
									<b-form-radio-group v-model="selectedResolution" @input="onResolutionSelect" :options="resolutionOpts"
										:aria-describedby="ariaDescribedby" class="d-flex flex-wrap" name="breakdown-option"
										stacked></b-form-radio-group>
								</b-form-group>
							</div>

							<div v-if="!copyVideo && selectedResolution === 'custom'"
								class="d-flex justify-content-between align-items-center">
								<div class="mr-4 w-100">
									<div class="d-flex justify-content-between align-items-center text-dark-6 mb-2 mt-4 mt-md-0">
										<h6 class="text-dark-8 text-s-s text-500 m-0">Width</h6>
									</div>
									<b-input-group size="md" class="mb-3">
										<b-form-input v-model="width"></b-form-input>
									</b-input-group>
								</div>

								<div class="w-100">
									<div class="d-flex justify-content-between align-items-center text-dark-6 mb-2 mt-4 mt-md-0">
										<h6 class="text-dark-8 text-s-s text-500 m-0">Height</h6>
									</div>
									<b-input-group size="md" class="mb-3">
										<b-form-input v-model="height"></b-form-input>
									</b-input-group>
								</div>
							</div>
							<div v-if="formErrors.width.error || formErrors.height.error"
								class="d-flex justify-content-between align-items-center mb-4">
								<span class="c-text-error text-s-s w-100 mr-4">{{ formErrors.width.show ? formErrors.width.error : ''
								}}</span>
								<span class="c-text-error text-s-s w-100">{{ formErrors.height.show ? formErrors.height.error : ''
								}}</span>
							</div>

							<div v-if="!copyVideo" class="d-flex justify-content-between align-items-center">
								<div class="mr-4 w-100">
									<div class="d-flex justify-content-between align-items-center text-dark-6 mb-2 mt-4 mt-md-0">
										<h6 class="text-dark-8 text-s-s text-500 m-0">Video Bitrate</h6>
									</div>
									<b-input-group size="md" class="mb-3">
										<b-form-input v-model="videoBitrate"
											@change="formFieldValueTypeCheck('videoBitrate', videoBitrate)"></b-form-input>
									</b-input-group>
								</div>

								<div class="">
									<div class="d-flex justify-content-between align-items-center text-dark-6 mb-2 mt-4 mt-md-0">
										<h6 class="text-dark-8 text-s-s text-500 m-0">FPS</h6>
									</div>
									<b-input-group size="md" class="mb-3">
										<b-dropdown variant="dark-3" size="md" class="mr-2 propdown-filter"
											toggle-class="d-flex align-items-center justify-content-between font-weight-normal"
											menu-class="dropdown-menu_md w-100">
											<template #button-content>
												<span>
													<span class="fps-name">{{ selectedFps ? selectedFps : 'Select an option' }}</span>
												</span>
											</template>
											<b-dropdown-item v-for="(fps, idx) in fpsOpts" :key="idx" @click="onFpsSelect(fps)">
												<div class="selected a region-dropdown-item">
													<span class="fps-name">{{ fps.name }}</span>
												</div>
											</b-dropdown-item>
										</b-dropdown>
									</b-input-group>
								</div>

							</div>

							<div v-if="formErrors.videoBitrate.error" class="d-flex justify-content-between align-items-center">
								<span class="c-text-error text-s-s">{{ formErrors.videoBitrate.show ? formErrors.videoBitrate.error : ''
								}}</span>
							</div>

							<div v-if="!copyVideo" class="d-flex justify-content-between align-items-center">
								<div class="d-flex align-items-center mb-2">
									<h6 class="text-dark-8 text-m-s text-500" style="margin: 0;">Deinterlace</h6>

									<b-form-checkbox v-model="deinterlace" size="sm" class="mb-md-0 ml-5 mt-1" switch>
									</b-form-checkbox>

									<svg class="mt-1" v-b-tooltip.hover title="Convert interlaced video to progressive" width="16"
										height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd"
											d="M7.9999 2.10039C4.74142 2.10039 2.0999 4.74191 2.0999 8.00039C2.0999 11.2589 4.74142 13.9004 7.9999 13.9004C11.2584 13.9004 13.8999 11.2589 13.8999 8.00039C13.8999 4.74191 11.2584 2.10039 7.9999 2.10039ZM0.899902 8.00039C0.899902 4.07917 4.07868 0.900391 7.9999 0.900391C11.9211 0.900391 15.0999 4.07917 15.0999 8.00039C15.0999 11.9216 11.9211 15.1004 7.9999 15.1004C4.07868 15.1004 0.899902 11.9216 0.899902 8.00039ZM8.99988 5.5004C8.99988 6.05268 8.55216 6.5004 7.99988 6.5004C7.44759 6.5004 6.99988 6.05268 6.99988 5.5004C6.99988 4.94811 7.44759 4.5004 7.99988 4.5004C8.55216 4.5004 8.99988 4.94811 8.99988 5.5004ZM8.59988 8.5004C8.59988 8.16903 8.33125 7.9004 7.99988 7.9004C7.66851 7.9004 7.39988 8.16903 7.39988 8.5004V11.0004C7.39988 11.3318 7.66851 11.6004 7.99988 11.6004C8.33125 11.6004 8.59988 11.3318 8.59988 11.0004V8.5004Z"
											fill="#8794B5" />
									</svg>

								</div>
							</div>

							<div v-if="!copyVideo" class="d-flex justify-content-between align-items-center">
								<div class="d-flex align-items-center mb-2">
									<h6 class="text-dark-8 text-m-s text-500 m-0">Interlace</h6>

									<b-form-checkbox
											v-model="interlace"
											size="sm"
											class="mb-md-0 ml-5 mt-1" switch>
										</b-form-checkbox>

									<svg
										class="mt-1"
										v-b-tooltip.hover
										title="Convert progressive video to interlaced"
										width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M7.9999 2.10039C4.74142 2.10039 2.0999 4.74191 2.0999 8.00039C2.0999 11.2589 4.74142 13.9004 7.9999 13.9004C11.2584 13.9004 13.8999 11.2589 13.8999 8.00039C13.8999 4.74191 11.2584 2.10039 7.9999 2.10039ZM0.899902 8.00039C0.899902 4.07917 4.07868 0.900391 7.9999 0.900391C11.9211 0.900391 15.0999 4.07917 15.0999 8.00039C15.0999 11.9216 11.9211 15.1004 7.9999 15.1004C4.07868 15.1004 0.899902 11.9216 0.899902 8.00039ZM8.99988 5.5004C8.99988 6.05268 8.55216 6.5004 7.99988 6.5004C7.44759 6.5004 6.99988 6.05268 6.99988 5.5004C6.99988 4.94811 7.44759 4.5004 7.99988 4.5004C8.55216 4.5004 8.99988 4.94811 8.99988 5.5004ZM8.59988 8.5004C8.59988 8.16903 8.33125 7.9004 7.99988 7.9004C7.66851 7.9004 7.39988 8.16903 7.39988 8.5004V11.0004C7.39988 11.3318 7.66851 11.6004 7.99988 11.6004C8.33125 11.6004 8.59988 11.3318 8.59988 11.0004V8.5004Z" fill="#8794B5"/>
									</svg>

								</div>
							</div>

							<hr class="mb-3">

							<div class="d-flex justify-content-between align-items-center mb-2">
								<label class="text-s-l text-light-2 text-500 cursor-pointer flex items-center" id="audio-info-tooltip">
									Audio
									<svg class="ml-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd"
											d="M7.9999 2.10039C4.74142 2.10039 2.0999 4.74191 2.0999 8.00039C2.0999 11.2589 4.74142 13.9004 7.9999 13.9004C11.2584 13.9004 13.8999 11.2589 13.8999 8.00039C13.8999 4.74191 11.2584 2.10039 7.9999 2.10039ZM0.899902 8.00039C0.899902 4.07917 4.07868 0.900391 7.9999 0.900391C11.9211 0.900391 15.0999 4.07917 15.0999 8.00039C15.0999 11.9216 11.9211 15.1004 7.9999 15.1004C4.07868 15.1004 0.899902 11.9216 0.899902 8.00039ZM8.99988 5.5004C8.99988 6.05268 8.55216 6.5004 7.99988 6.5004C7.44759 6.5004 6.99988 6.05268 6.99988 5.5004C6.99988 4.94811 7.44759 4.5004 7.99988 4.5004C8.55216 4.5004 8.99988 4.94811 8.99988 5.5004ZM8.59988 8.5004C8.59988 8.16903 8.33125 7.9004 7.99988 7.9004C7.66851 7.9004 7.39988 8.16903 7.39988 8.5004V11.0004C7.39988 11.3318 7.66851 11.6004 7.99988 11.6004C8.33125 11.6004 8.59988 11.3318 8.59988 11.0004V8.5004Z"
											fill="#8794B5" />
									</svg>
								</label>

								<b-tooltip target="audio-info-tooltip" placement="top">
									<div style="text-align: start; padding-right: 20px;">
										<label class="text-s-l color-light text-500 mb-0" style="color: white;">
											Audio Bitrate
										</label>
										<br>
										<span>Min value: 32</span><br>
										<span>Max value: 320</span>

										<br><br>
										<label class="text-s-l color-light text-500 mb-0" style="color: white;">
											Volume
										</label>
										<br>
										<span>Min value: 0</span><br>
										<span>Max value: 2</span>

									</div>
								</b-tooltip>


								<div class="d-flex justify-content-between align-items-center">
									<b-form-checkbox v-model="copyAudio" size="sm" class="mb-md-0" switch>
									</b-form-checkbox>
									<label class="text-s-xs text-dark-7 text-500 mt-1">Copy from input</label>
								</div>

							</div>

							<div v-if="!copyAudio" class="d-flex flex-column justify-content-between">
								<div class="">
									<div class="d-flex justify-content-between align-items-center text-dark-6 mb-2 mt-4 mt-md-0">
										<h6 class="text-dark-8 text-s-s text-500 m-0 d-flex align-items-center">
											<span class="mr-2">Filter Track</span>
											<svg v-b-tooltip.hover title="Choose the audio track to transcode" width="16" height="16"
												viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path fill-rule="evenodd" clip-rule="evenodd"
													d="M7.9999 2.10039C4.74142 2.10039 2.0999 4.74191 2.0999 8.00039C2.0999 11.2589 4.74142 13.9004 7.9999 13.9004C11.2584 13.9004 13.8999 11.2589 13.8999 8.00039C13.8999 4.74191 11.2584 2.10039 7.9999 2.10039ZM0.899902 8.00039C0.899902 4.07917 4.07868 0.900391 7.9999 0.900391C11.9211 0.900391 15.0999 4.07917 15.0999 8.00039C15.0999 11.9216 11.9211 15.1004 7.9999 15.1004C4.07868 15.1004 0.899902 11.9216 0.899902 8.00039ZM8.99988 5.5004C8.99988 6.05268 8.55216 6.5004 7.99988 6.5004C7.44759 6.5004 6.99988 6.05268 6.99988 5.5004C6.99988 4.94811 7.44759 4.5004 7.99988 4.5004C8.55216 4.5004 8.99988 4.94811 8.99988 5.5004ZM8.59988 8.5004C8.59988 8.16903 8.33125 7.9004 7.99988 7.9004C7.66851 7.9004 7.39988 8.16903 7.39988 8.5004V11.0004C7.39988 11.3318 7.66851 11.6004 7.99988 11.6004C8.33125 11.6004 8.59988 11.3318 8.59988 11.0004V8.5004Z"
													fill="#8794B5" />
											</svg>
										</h6>

										<b-form-checkbox v-model="audioTrackEnabled" size="sm" class="mb-md-0" switch>
										</b-form-checkbox>

									</div>
									<b-input-group size="md" class="mb-3">
										<b-dropdown v-show="audioTrackEnabled" variant="dark-3" size="md" class="mr-2 propdown-filter w-100"
											toggle-class="d-flex align-items-center justify-content-between font-weight-normal"
											menu-class="dropdown-menu_md w-100">
											<template #button-content>
												<span>
													<span class="fps-name">{{ selectedAudioTrack }}</span>
												</span>
											</template>
											<b-dropdown-item v-for="(track, idx) in audioTracks" :key="idx" @click="onAudioTrackSelect(track)">
												<div class="selected a region-dropdown-item">
													<span class="fps-name">{{ track.name }}</span>
												</div>
											</b-dropdown-item>
										</b-dropdown>
									</b-input-group>
								</div>

								<div class="d-flex">
									<div class="mr-4 w-100">
										<div class="d-flex justify-content-between align-items-center text-dark-6 mb-2 mt-4 mt-md-0">
											<h6 class="text-dark-8 text-s-s text-500 m-0">Audio Bitrate</h6>
										</div>
										<b-input-group size="md" class="mb-3">
											<b-form-input v-model="audioBitrate"></b-form-input>
										</b-input-group>
									</div>

									<div class="w-100">
										<div class="d-flex justify-content-between align-items-center text-dark-6 mb-2 mt-4 mt-md-0">
											<h6 class="text-dark-8 text-s-s text-500 m-0">Volume</h6>
										</div>
										<b-input-group size="md" class="mb-3">
											<b-form-input v-model="volume"></b-form-input>
										</b-input-group>
									</div>

								</div>
							</div>

							<div v-if="formErrors.audioBitrate.error || formErrors.volume.error"
								class="d-flex flex-column justify-content-between align-items-center mb-4">
								<span class="c-text-error text-s-s w-100">{{ formErrors.audioBitrate.show ? formErrors.audioBitrate.error
									: '' }}</span>
								<span class="c-text-error text-s-s w-100">{{ formErrors.volume.show ? formErrors.volume.error : ''
								}}</span>
							</div>

							<hr class="mt-2">

							<div id="save-button-tooltip" class="d-inline-block">
								<b-button
									:disabled="saveDisabled || !transcoderFlag"
									variant="primary"
									@click="saveSettings"
								>
								<span>{{ saveProcessing ? 'Saving...' : 'Save' }}</span>
								</b-button>
							</div>

							<b-tooltip v-if="!transcoderFlag" target="save-button-tooltip" triggers="hover">
								<a class="text-dark-8 text-s-ss text-500 text-underline" target="_blank" href="https://castr.com/app/subscribe">Upgrade</a> plan to save changes.
							</b-tooltip>
							<b-button variant="outline-secondary" size="md" class="ml-2" @click="cancelSettings">
								<span>Cancel</span>
							</b-button>
						</div>
					</b-col>

					<b-col lg="12" class="col-xl-4">
						<div v-if="this.streamAlive" class="flex flex-col phone-number-section mb-4 p-4" style="">
							<div class="d-flex justify-content-between align-items-center" style="">
								<label class="text-s-m text-light-2 text-500">Incoming stream</label>
							</div>
							<div v-if="mediaPulse && mediaPulse.meta && mediaPulse.meta.video" class="mr-2 mt-2">
								<div class="d-flex align-items-center flex-wrap">
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd"
											d="M8.78261 1.8122C8.54374 1.75485 8.28125 1.75003 7.51178 1.75003H5.7C5.12757 1.75003 4.74336 1.75062 4.44748 1.77479C4.16036 1.79825 4.02307 1.84013 3.93251 1.88627C3.69731 2.00612 3.50609 2.19734 3.38624 2.43254C3.3401 2.5231 3.29822 2.66039 3.27476 2.94751C3.25058 3.24339 3.25 3.6276 3.25 4.20003V6.25003H8.4L8.42622 6.25003C8.6837 6.25001 8.92019 6.25 9.11787 6.26615C9.33101 6.28356 9.56418 6.32342 9.79449 6.44077C10.1238 6.60855 10.3915 6.87627 10.5593 7.20555C10.6766 7.43586 10.7165 7.66903 10.7339 7.88216C10.75 8.07984 10.75 8.31632 10.75 8.5738L10.75 8.60003V10.4L10.75 10.4263C10.75 10.6837 10.75 10.9202 10.7339 11.1179C10.7165 11.331 10.6766 11.5642 10.5593 11.7945C10.3915 12.1238 10.1238 12.3915 9.79449 12.5593C9.56418 12.6766 9.33101 12.7165 9.11787 12.7339C8.92019 12.7501 8.68371 12.7501 8.42623 12.75L8.4 12.75H3.25485C3.25741 12.8593 3.26132 12.9558 3.26729 13.0433C3.28372 13.284 3.31319 13.4012 3.34515 13.4784C3.47202 13.7847 3.71536 14.028 4.02165 14.1549C4.0988 14.1868 4.21602 14.2163 4.45674 14.2327C4.70421 14.2496 5.0238 14.25 5.5 14.25H10.3C10.8724 14.25 11.2566 14.2494 11.5525 14.2253C11.8396 14.2018 11.9769 14.1599 12.0675 14.1138C12.3027 13.9939 12.4939 13.8027 12.6138 13.5675C12.6599 13.477 12.7018 13.3397 12.7252 13.0526C12.7494 12.7567 12.75 12.3725 12.75 11.8V6.98826C12.75 6.21879 12.7452 5.95629 12.6878 5.71742C12.6327 5.48784 12.5418 5.26836 12.4184 5.06705C12.2901 4.85759 12.1079 4.66857 11.5638 4.12447L10.3756 2.93625C9.83146 2.39215 9.64244 2.20995 9.43298 2.08159C9.23167 1.95823 9.01219 1.86732 8.78261 1.8122ZM2.5 11.25H8.4C8.6924 11.25 8.8666 11.2494 8.99573 11.2389C9.07453 11.2325 9.10766 11.224 9.11654 11.2212C9.16118 11.1977 9.19766 11.1612 9.22118 11.1166C9.22393 11.1077 9.23243 11.0746 9.23887 10.9958C9.24942 10.8666 9.25 10.6924 9.25 10.4V8.60003C9.25 8.30763 9.24942 8.13343 9.23887 8.00431C9.23243 7.9255 9.22393 7.89237 9.22118 7.88349C9.19766 7.83886 9.16118 7.80238 9.11654 7.77886C9.10766 7.7761 9.07453 7.7676 8.99573 7.76117C8.8666 7.75062 8.6924 7.75003 8.4 7.75003H2.5C2.25677 7.75003 2.11191 7.75044 2.0039 7.75781C1.93707 7.76237 1.90867 7.76847 1.90131 7.77034C1.84248 7.79561 1.79558 7.84251 1.77031 7.90134C1.76844 7.9087 1.76234 7.9371 1.75778 8.00393C1.75041 8.11194 1.75 8.2568 1.75 8.50003V10.5C1.75 10.7433 1.75041 10.8881 1.75778 10.9961C1.76234 11.063 1.76844 11.0914 1.77031 11.0987C1.79558 11.1576 1.84248 11.2045 1.90131 11.2297C1.90867 11.2316 1.93708 11.2377 2.0039 11.2423C2.11191 11.2496 2.25677 11.25 2.5 11.25ZM9.11913 7.77976C9.11912 7.77978 9.11861 7.7796 9.11767 7.77922L9.11913 7.77976ZM9.22027 7.88091C9.22028 7.88088 9.22048 7.88135 9.22082 7.88239L9.22027 7.88091ZM9.22027 11.1192C9.22026 11.1191 9.22044 11.1186 9.22083 11.1176L9.22027 11.1192ZM9.11913 11.2203C9.11917 11.2203 9.11869 11.2205 9.11761 11.2209L9.11913 11.2203ZM1.75402 12.7248C1.61823 12.7077 1.47511 12.6768 1.33031 12.6168C0.901507 12.4392 0.560827 12.0985 0.383213 11.6697C0.30099 11.4712 0.273377 11.2759 0.261256 11.0982C0.249976 10.9329 0.249988 10.7361 0.250001 10.5218L0.250002 10.5V8.50003L0.250001 8.47828C0.249988 8.264 0.249976 8.06715 0.261256 7.90182C0.273377 7.72418 0.30099 7.52884 0.383213 7.33034C0.560827 6.90154 0.901507 6.56086 1.33031 6.38324C1.47368 6.32386 1.6154 6.29296 1.75 6.27581V4.20003L1.75 4.1696C1.74999 3.63544 1.74998 3.1896 1.77974 2.82536C1.81078 2.44548 1.87789 2.08882 2.04973 1.75156C2.31339 1.23411 2.73408 0.813416 3.25153 0.549764C3.58879 0.37792 3.94545 0.310809 4.32533 0.279771C4.68957 0.250012 5.13541 0.250021 5.66957 0.250032L5.7 0.250032H7.51178C7.54065 0.250032 7.56913 0.250024 7.59724 0.250016C8.2488 0.249827 8.69981 0.249697 9.13278 0.353645C9.51542 0.445508 9.88121 0.597024 10.2167 0.802631C10.5964 1.03529 10.9152 1.35429 11.3758 1.81515C11.3957 1.83503 11.4158 1.85518 11.4362 1.87559L12.6244 3.06381C12.6449 3.08423 12.665 3.10437 12.6849 3.12424C13.1457 3.58483 13.4647 3.90364 13.6974 4.2833C13.903 4.61882 14.0545 4.98462 14.1464 5.36725C14.2503 5.80023 14.2502 6.25124 14.25 6.9028C14.25 6.93091 14.25 6.95939 14.25 6.98826V11.8V11.8305C14.25 12.3646 14.25 12.8105 14.2203 13.1747C14.1892 13.5546 14.1221 13.9112 13.9503 14.2485C13.6866 14.766 13.2659 15.1866 12.7485 15.4503C12.4112 15.6221 12.0546 15.6893 11.6747 15.7203C11.3104 15.7501 10.8646 15.75 10.3305 15.75H10.3H5.5H5.47474C5.03029 15.75 4.65925 15.75 4.35464 15.7293C4.03754 15.7076 3.73801 15.661 3.44762 15.5407C2.7738 15.2616 2.23844 14.7262 1.95933 14.0524C1.83905 13.762 1.79241 13.4625 1.77077 13.1454C1.76202 13.0171 1.75696 12.8771 1.75402 12.7248Z"
											fill="#C5A2FF" />
									</svg>
									<span class="ml-2 text-s-m text-light-2 text-500">{{ mediaPulse.meta.video.codec }}</span>
									<span class="mx-2">&#x2022;</span>
									<span class="text-s-m text-light-2 text-500">{{ mediaPulse.meta.video.width }} x {{
										mediaPulse.meta.video.height }} ({{ mediaPulse.meta.video.bitrate }}kbps)</span>
								</div>

								<div v-if="mediaPulse && mediaPulse.meta && mediaPulse.meta.audio" class="d-flex align-items-center">
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<g clip-path="url(#clip0_2141_14482)">
											<path
												d="M9.29813 0.586093C9.11253 0.497559 8.89387 0.521026 8.73387 0.650093L3.5456 4.80049H1.06667C0.478933 4.80049 0 5.27943 0 5.86716V10.1338C0 10.7216 0.478933 11.2005 1.06667 11.2005H3.5456L8.7328 15.3509C8.82987 15.4277 8.94827 15.4672 9.06667 15.4672C9.1456 15.4672 9.22453 15.4501 9.29813 15.4149C9.48267 15.3253 9.6 15.1386 9.6 14.9338V1.06716C9.6 0.862359 9.48267 0.675693 9.29813 0.586093ZM3.2 10.1338H1.06667V5.86716H3.2V10.1338ZM8.53333 13.8234L4.26667 10.4101V5.59089L8.53333 2.17756V13.8234Z"
												fill="#74DE85" />
											<path
												d="M12.3009 4.2285C12.0908 4.0205 11.7537 4.0237 11.5468 4.23276C11.3398 4.4429 11.342 4.77996 11.551 4.9869C12.3564 5.7837 12.8001 6.85356 12.8001 8.00023C12.8001 9.1469 12.3564 10.2168 11.551 11.0136C11.3409 11.2205 11.3388 11.5576 11.5468 11.7677C11.6513 11.8733 11.7889 11.9256 11.9254 11.9256C12.0609 11.9256 12.1964 11.8744 12.3009 11.7709C13.311 10.7736 13.8668 9.4349 13.8668 8.00023C13.8668 6.56556 13.311 5.2269 12.3009 4.2285Z"
												fill="#74DE85" />
											<path
												d="M13.805 2.72569C13.596 2.51876 13.2578 2.51983 13.0509 2.72889C12.844 2.93796 12.845 3.27609 13.0541 3.48303C14.2658 4.68516 14.9336 6.28943 14.9336 8.00036C14.9336 9.71129 14.2658 11.3156 13.0541 12.5177C12.845 12.7246 12.844 13.0628 13.0509 13.2718C13.1554 13.3774 13.292 13.4297 13.4296 13.4297C13.565 13.4297 13.7005 13.3785 13.805 13.275C15.2205 11.8713 16.0002 9.99823 16.0002 8.00036C16.0002 6.00249 15.2205 4.12943 13.805 2.72569Z"
												fill="#74DE85" />
										</g>
										<defs>
											<clipPath id="clip0_2141_14482">
												<rect width="16" height="16" fill="white" />
											</clipPath>
										</defs>
									</svg>
									<span class="ml-2 text-s-m text-light-2 text-500">{{ mediaPulse.meta.audio.codec }} {{
										mediaPulse.meta.audio.channels === 2 ? 'stereo' : '' }} ({{ mediaPulse.meta.audio.bitrate }}kbps)</span>
								</div>

								<div v-if="mediaPulse && mediaPulse.meta && mediaPulse.meta.video" class="d-flex align-items-center">
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd"
											d="M3.5 2C3.91421 2 4.25 2.33579 4.25 2.75L4.25 13.75C4.25 14.1642 3.91421 14.5 3.5 14.5C3.08579 14.5 2.75 14.1642 2.75 13.75V2.75C2.75 2.33579 3.08579 2 3.5 2ZM8 8C8.41421 8 8.75 8.33579 8.75 8.75V13.75C8.75 14.1642 8.41421 14.5 8 14.5C7.58579 14.5 7.25 14.1642 7.25 13.75V8.75C7.25 8.33579 7.58579 8 8 8ZM13.25 5.75C13.25 5.33579 12.9142 5 12.5 5C12.0858 5 11.75 5.33579 11.75 5.75V13.75C11.75 14.1642 12.0858 14.5 12.5 14.5C12.9142 14.5 13.25 14.1642 13.25 13.75V5.75Z"
											fill="#F06F9D" />
									</svg>

									<span class="ml-2 text-s-m text-light-2 text-500">{{ mediaPulse.meta.video.fps }} FPS</span>
								</div>

							</div>
							<hr class="my-4">
							<div class="d-flex justify-content-between align-items-center" style="">
								<label class="text-s-m text-light-2 text-500">Transcoded</label>
							</div>
							<div v-if="destinationAlive" class="mr-2 mt-2">

								<div v-if="destinationMediaPulse && destinationMediaPulse.meta && destinationMediaPulse.meta.video"
									class="d-flex align-items-center flex-wrap">
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd"
											d="M8.78261 1.8122C8.54374 1.75485 8.28125 1.75003 7.51178 1.75003H5.7C5.12757 1.75003 4.74336 1.75062 4.44748 1.77479C4.16036 1.79825 4.02307 1.84013 3.93251 1.88627C3.69731 2.00612 3.50609 2.19734 3.38624 2.43254C3.3401 2.5231 3.29822 2.66039 3.27476 2.94751C3.25058 3.24339 3.25 3.6276 3.25 4.20003V6.25003H8.4L8.42622 6.25003C8.6837 6.25001 8.92019 6.25 9.11787 6.26615C9.33101 6.28356 9.56418 6.32342 9.79449 6.44077C10.1238 6.60855 10.3915 6.87627 10.5593 7.20555C10.6766 7.43586 10.7165 7.66903 10.7339 7.88216C10.75 8.07984 10.75 8.31632 10.75 8.5738L10.75 8.60003V10.4L10.75 10.4263C10.75 10.6837 10.75 10.9202 10.7339 11.1179C10.7165 11.331 10.6766 11.5642 10.5593 11.7945C10.3915 12.1238 10.1238 12.3915 9.79449 12.5593C9.56418 12.6766 9.33101 12.7165 9.11787 12.7339C8.92019 12.7501 8.68371 12.7501 8.42623 12.75L8.4 12.75H3.25485C3.25741 12.8593 3.26132 12.9558 3.26729 13.0433C3.28372 13.284 3.31319 13.4012 3.34515 13.4784C3.47202 13.7847 3.71536 14.028 4.02165 14.1549C4.0988 14.1868 4.21602 14.2163 4.45674 14.2327C4.70421 14.2496 5.0238 14.25 5.5 14.25H10.3C10.8724 14.25 11.2566 14.2494 11.5525 14.2253C11.8396 14.2018 11.9769 14.1599 12.0675 14.1138C12.3027 13.9939 12.4939 13.8027 12.6138 13.5675C12.6599 13.477 12.7018 13.3397 12.7252 13.0526C12.7494 12.7567 12.75 12.3725 12.75 11.8V6.98826C12.75 6.21879 12.7452 5.95629 12.6878 5.71742C12.6327 5.48784 12.5418 5.26836 12.4184 5.06705C12.2901 4.85759 12.1079 4.66857 11.5638 4.12447L10.3756 2.93625C9.83146 2.39215 9.64244 2.20995 9.43298 2.08159C9.23167 1.95823 9.01219 1.86732 8.78261 1.8122ZM2.5 11.25H8.4C8.6924 11.25 8.8666 11.2494 8.99573 11.2389C9.07453 11.2325 9.10766 11.224 9.11654 11.2212C9.16118 11.1977 9.19766 11.1612 9.22118 11.1166C9.22393 11.1077 9.23243 11.0746 9.23887 10.9958C9.24942 10.8666 9.25 10.6924 9.25 10.4V8.60003C9.25 8.30763 9.24942 8.13343 9.23887 8.00431C9.23243 7.9255 9.22393 7.89237 9.22118 7.88349C9.19766 7.83886 9.16118 7.80238 9.11654 7.77886C9.10766 7.7761 9.07453 7.7676 8.99573 7.76117C8.8666 7.75062 8.6924 7.75003 8.4 7.75003H2.5C2.25677 7.75003 2.11191 7.75044 2.0039 7.75781C1.93707 7.76237 1.90867 7.76847 1.90131 7.77034C1.84248 7.79561 1.79558 7.84251 1.77031 7.90134C1.76844 7.9087 1.76234 7.9371 1.75778 8.00393C1.75041 8.11194 1.75 8.2568 1.75 8.50003V10.5C1.75 10.7433 1.75041 10.8881 1.75778 10.9961C1.76234 11.063 1.76844 11.0914 1.77031 11.0987C1.79558 11.1576 1.84248 11.2045 1.90131 11.2297C1.90867 11.2316 1.93708 11.2377 2.0039 11.2423C2.11191 11.2496 2.25677 11.25 2.5 11.25ZM9.11913 7.77976C9.11912 7.77978 9.11861 7.7796 9.11767 7.77922L9.11913 7.77976ZM9.22027 7.88091C9.22028 7.88088 9.22048 7.88135 9.22082 7.88239L9.22027 7.88091ZM9.22027 11.1192C9.22026 11.1191 9.22044 11.1186 9.22083 11.1176L9.22027 11.1192ZM9.11913 11.2203C9.11917 11.2203 9.11869 11.2205 9.11761 11.2209L9.11913 11.2203ZM1.75402 12.7248C1.61823 12.7077 1.47511 12.6768 1.33031 12.6168C0.901507 12.4392 0.560827 12.0985 0.383213 11.6697C0.30099 11.4712 0.273377 11.2759 0.261256 11.0982C0.249976 10.9329 0.249988 10.7361 0.250001 10.5218L0.250002 10.5V8.50003L0.250001 8.47828C0.249988 8.264 0.249976 8.06715 0.261256 7.90182C0.273377 7.72418 0.30099 7.52884 0.383213 7.33034C0.560827 6.90154 0.901507 6.56086 1.33031 6.38324C1.47368 6.32386 1.6154 6.29296 1.75 6.27581V4.20003L1.75 4.1696C1.74999 3.63544 1.74998 3.1896 1.77974 2.82536C1.81078 2.44548 1.87789 2.08882 2.04973 1.75156C2.31339 1.23411 2.73408 0.813416 3.25153 0.549764C3.58879 0.37792 3.94545 0.310809 4.32533 0.279771C4.68957 0.250012 5.13541 0.250021 5.66957 0.250032L5.7 0.250032H7.51178C7.54065 0.250032 7.56913 0.250024 7.59724 0.250016C8.2488 0.249827 8.69981 0.249697 9.13278 0.353645C9.51542 0.445508 9.88121 0.597024 10.2167 0.802631C10.5964 1.03529 10.9152 1.35429 11.3758 1.81515C11.3957 1.83503 11.4158 1.85518 11.4362 1.87559L12.6244 3.06381C12.6449 3.08423 12.665 3.10437 12.6849 3.12424C13.1457 3.58483 13.4647 3.90364 13.6974 4.2833C13.903 4.61882 14.0545 4.98462 14.1464 5.36725C14.2503 5.80023 14.2502 6.25124 14.25 6.9028C14.25 6.93091 14.25 6.95939 14.25 6.98826V11.8V11.8305C14.25 12.3646 14.25 12.8105 14.2203 13.1747C14.1892 13.5546 14.1221 13.9112 13.9503 14.2485C13.6866 14.766 13.2659 15.1866 12.7485 15.4503C12.4112 15.6221 12.0546 15.6893 11.6747 15.7203C11.3104 15.7501 10.8646 15.75 10.3305 15.75H10.3H5.5H5.47474C5.03029 15.75 4.65925 15.75 4.35464 15.7293C4.03754 15.7076 3.73801 15.661 3.44762 15.5407C2.7738 15.2616 2.23844 14.7262 1.95933 14.0524C1.83905 13.762 1.79241 13.4625 1.77077 13.1454C1.76202 13.0171 1.75696 12.8771 1.75402 12.7248Z"
											fill="#C5A2FF" />
									</svg>
									<span class="ml-2 text-s-m text-light-2 text-500">{{ destinationMediaPulse.meta.video.codec }}</span>
									<span class="mx-2">&#x2022;</span>
									<span class="text-s-m text-light-2 text-500">{{ destinationMediaPulse.meta.video.width }} x {{
										destinationMediaPulse.meta.video.height }} ({{ destinationMediaPulse.meta.video.bitrate }}kbps)</span>
								</div>

								<div v-if="destinationMediaPulse && destinationMediaPulse.meta && destinationMediaPulse.meta.audio"
									class="d-flex align-items-center">
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<g clip-path="url(#clip0_2141_14482)">
											<path
												d="M9.29813 0.586093C9.11253 0.497559 8.89387 0.521026 8.73387 0.650093L3.5456 4.80049H1.06667C0.478933 4.80049 0 5.27943 0 5.86716V10.1338C0 10.7216 0.478933 11.2005 1.06667 11.2005H3.5456L8.7328 15.3509C8.82987 15.4277 8.94827 15.4672 9.06667 15.4672C9.1456 15.4672 9.22453 15.4501 9.29813 15.4149C9.48267 15.3253 9.6 15.1386 9.6 14.9338V1.06716C9.6 0.862359 9.48267 0.675693 9.29813 0.586093ZM3.2 10.1338H1.06667V5.86716H3.2V10.1338ZM8.53333 13.8234L4.26667 10.4101V5.59089L8.53333 2.17756V13.8234Z"
												fill="#74DE85" />
											<path
												d="M12.3009 4.2285C12.0908 4.0205 11.7537 4.0237 11.5468 4.23276C11.3398 4.4429 11.342 4.77996 11.551 4.9869C12.3564 5.7837 12.8001 6.85356 12.8001 8.00023C12.8001 9.1469 12.3564 10.2168 11.551 11.0136C11.3409 11.2205 11.3388 11.5576 11.5468 11.7677C11.6513 11.8733 11.7889 11.9256 11.9254 11.9256C12.0609 11.9256 12.1964 11.8744 12.3009 11.7709C13.311 10.7736 13.8668 9.4349 13.8668 8.00023C13.8668 6.56556 13.311 5.2269 12.3009 4.2285Z"
												fill="#74DE85" />
											<path
												d="M13.805 2.72569C13.596 2.51876 13.2578 2.51983 13.0509 2.72889C12.844 2.93796 12.845 3.27609 13.0541 3.48303C14.2658 4.68516 14.9336 6.28943 14.9336 8.00036C14.9336 9.71129 14.2658 11.3156 13.0541 12.5177C12.845 12.7246 12.844 13.0628 13.0509 13.2718C13.1554 13.3774 13.292 13.4297 13.4296 13.4297C13.565 13.4297 13.7005 13.3785 13.805 13.275C15.2205 11.8713 16.0002 9.99823 16.0002 8.00036C16.0002 6.00249 15.2205 4.12943 13.805 2.72569Z"
												fill="#74DE85" />
										</g>
										<defs>
											<clipPath id="clip0_2141_14482">
												<rect width="16" height="16" fill="white" />
											</clipPath>
										</defs>
									</svg>
									<span class="ml-2 text-s-m text-light-2 text-500">{{ destinationMediaPulse.meta.audio.codec }} {{
										destinationMediaPulse.meta.audio.channels === 2 ? 'stereo' : '' }}
										({{ destinationMediaPulse.meta.audio.bitrate }}kbps)</span>
								</div>

								<div v-if="destinationMediaPulse && destinationMediaPulse.meta && destinationMediaPulse.meta.video"
									class="d-flex align-items-center">
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd"
											d="M3.5 2C3.91421 2 4.25 2.33579 4.25 2.75L4.25 13.75C4.25 14.1642 3.91421 14.5 3.5 14.5C3.08579 14.5 2.75 14.1642 2.75 13.75V2.75C2.75 2.33579 3.08579 2 3.5 2ZM8 8C8.41421 8 8.75 8.33579 8.75 8.75V13.75C8.75 14.1642 8.41421 14.5 8 14.5C7.58579 14.5 7.25 14.1642 7.25 13.75V8.75C7.25 8.33579 7.58579 8 8 8ZM13.25 5.75C13.25 5.33579 12.9142 5 12.5 5C12.0858 5 11.75 5.33579 11.75 5.75V13.75C11.75 14.1642 12.0858 14.5 12.5 14.5C12.9142 14.5 13.25 14.1642 13.25 13.75V5.75Z"
											fill="#F06F9D" />
									</svg>

									<span class="ml-2 text-s-m text-light-2 text-500">{{ destinationMediaPulse.meta.video.fps }} FPS</span>
								</div>

							</div>
							<div v-else class="mr-2 mt-2 d-flex justify-content-center align-items-center">
								<span class="text-dark-8 text-s-s text-500 m-0">offline</span>
							</div>
						</div>


						<div class="phone-number-section p-4">
							<div class="d-flex justify-content-between align-items-center" style="">
								<label class="text-s-l text-light-2 text-500">Destination</label>
							</div>
							<div class="mr-2 mt-2 position-relative">
								<div class="d-flex justify-content-between align-items-center text-dark-6 mb-2 mt-4 mt-md-0">
									<h6 class="text-dark-8 text-s-s text-500 m-0">Link to</h6>
									<b-button v-if="destination" variant="icon" size="xs" class="p-0 text-s-s text-reset border-0"
										@click="setDestination(null)">Remove
									</b-button>
								</div>

								<div class="d-flex justify-content-between align-items-center">
									<b-dropdown :disabled="hasLiveSubscription && !hasLiveSubscription.enabled" ref="source" right
										variant="dark-3" size="md" id="stream-source" menu-class="bg-dark-3 stream-source-menu"
										toggle-class="justify-content-between text-truncate w-full" class="w-full">
										<template #button-content>

											<div class="text-truncate flex items-center pr-6">
												<svg class="mr-2 shrink-0" width="16" height="16" viewBox="0 0 16 16" fill="none"
													xmlns="http://www.w3.org/2000/svg">
													<path fill-rule="evenodd" clip-rule="evenodd"
														d="M4.9999 2.40039H4.97411C4.29592 2.40039 3.75045 2.40038 3.30905 2.43644C2.85506 2.47354 2.4586 2.55175 2.09253 2.73827C1.50923 3.03548 1.03499 3.50972 0.737783 4.09302C0.55126 4.45909 0.473048 4.85555 0.435956 5.30954C0.399892 5.75093 0.399897 6.29641 0.399902 6.97459V7.00039V9.00039V9.02619C0.399897 9.70437 0.399892 10.2498 0.435956 10.6912C0.473048 11.1452 0.55126 11.5417 0.737783 11.9078C1.03499 12.4911 1.50923 12.9653 2.09253 13.2625C2.4586 13.449 2.85506 13.5272 3.30905 13.5643C3.75045 13.6004 4.29593 13.6004 4.97411 13.6004H4.97412H4.9999H6.9999H7.02568H7.02569C7.70388 13.6004 8.24936 13.6004 8.69076 13.5643C9.14474 13.5272 9.5412 13.449 9.90727 13.2625C10.4906 12.9653 10.9648 12.4911 11.262 11.9078C11.4485 11.5417 11.5268 11.1452 11.5638 10.6912C11.579 10.506 11.5878 10.3025 11.5929 10.0785L13.9169 11.5311C14.6496 11.989 15.5999 11.4622 15.5999 10.5983V5.40252C15.5999 4.53854 14.6496 4.01181 13.9169 4.46972L11.5929 5.92224C11.5878 5.69827 11.579 5.49474 11.5638 5.30954C11.5268 4.85555 11.4485 4.45909 11.262 4.09302C10.9648 3.50972 10.4906 3.03548 9.90727 2.73827C9.5412 2.55175 9.14474 2.47354 8.69076 2.43644C8.24936 2.40038 7.70388 2.40039 7.0257 2.40039H6.9999H4.9999ZM11.5999 7.33294V8.66784L14.3999 10.4178V5.58294L11.5999 7.33294ZM10.3999 7.27752V7.00039C10.3999 6.29043 10.3994 5.79404 10.3678 5.40725C10.3368 5.02748 10.2788 4.80652 10.1928 4.63781C10.0107 4.2803 9.71999 3.98964 9.36248 3.80748C9.19378 3.72152 8.97281 3.66349 8.59304 3.63246C8.20626 3.60086 7.70987 3.60039 6.9999 3.60039H4.9999C4.28994 3.60039 3.79355 3.60086 3.40677 3.63246C3.02699 3.66349 2.80603 3.72152 2.63732 3.80748C2.27981 3.98964 1.98915 4.2803 1.80699 4.63781C1.72103 4.80652 1.663 5.02748 1.63197 5.40725C1.60037 5.79404 1.5999 6.29042 1.5999 7.00039V9.00039C1.5999 9.71036 1.60037 10.2067 1.63197 10.5935C1.663 10.9733 1.72103 11.1943 1.80699 11.363C1.98915 11.7205 2.27981 12.0111 2.63732 12.1933C2.80603 12.2793 3.02699 12.3373 3.40677 12.3683C3.79355 12.3999 4.28994 12.4004 4.9999 12.4004H6.9999C7.70987 12.4004 8.20626 12.3999 8.59304 12.3683C8.97281 12.3373 9.19378 12.2793 9.36248 12.1933C9.71999 12.0111 10.0107 11.7205 10.1928 11.363C10.2788 11.1943 10.3368 10.9733 10.3678 10.5935C10.3994 10.2067 10.3999 9.71036 10.3999 9.00039V8.72327V7.27752Z"
														fill="white" />
												</svg>
												{{ destination ? destinationStream.name.slice(0, 40) : 'Choose a destination' }}
											</div>
										</template>
										<b-dropdown-text text-class="px-0">
											<b-tabs class="tabs-light" nav-class="px-3 tabs-light-border">
												<div v-if="allInOneStreams.length > 0" class="px-2 my-3">
													<b-input-group size="md" class="bg-dark-5 rounded">
														<template #prepend>
															<b-input-group-text class="bg-transparent border-0 text-dark-6">
																<svg width="16" height="16" viewBox="0 0 16 16" fill="none"
																	xmlns="http://www.w3.org/2000/svg">
																	<path fill-rule="evenodd" clip-rule="evenodd"
																		d="M2.25 6.75C2.25 4.26472 4.26472 2.25 6.75 2.25C9.23528 2.25 11.25 4.26472 11.25 6.75C11.25 9.23528 9.23528 11.25 6.75 11.25C4.26472 11.25 2.25 9.23528 2.25 6.75ZM6.75 0.75C3.43629 0.75 0.75 3.43629 0.75 6.75C0.75 10.0637 3.43629 12.75 6.75 12.75C8.13653 12.75 9.41322 12.2797 10.4292 11.4899L13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L11.4899 10.4292C12.2797 9.41322 12.75 8.13653 12.75 6.75C12.75 3.43629 10.0637 0.75 6.75 0.75Z"
																		fill="currentColor" />
																</svg>
															</b-input-group-text>
														</template>
														<b-form-input ref="searchWidgetInputElement" placeholder="Search for files" size="md"
															class="border-0" v-model="search"></b-form-input>
														<b-button @click="search = ''" variant="icon" size="md" class="search-clear"
															:class="{ 'active': search.length > 0 }">
															<svg class="text-dark-8" width="16" height="17" viewBox="0 0 16 17" fill="none"
																xmlns="http://www.w3.org/2000/svg">
																<path fill-rule="evenodd" clip-rule="evenodd"
																	d="M8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5ZM6.03033 5.46967C5.73744 5.17678 5.26256 5.17678 4.96967 5.46967C4.67678 5.76256 4.67678 6.23744 4.96967 6.53033L6.93934 8.5L4.96967 10.4697C4.67678 10.7626 4.67678 11.2374 4.96967 11.5303C5.26256 11.8232 5.73744 11.8232 6.03033 11.5303L8 9.56066L9.96967 11.5303C10.2626 11.8232 10.7374 11.8232 11.0303 11.5303C11.3232 11.2374 11.3232 10.7626 11.0303 10.4697L9.06066 8.5L11.0303 6.53033C11.3232 6.23744 11.3232 5.76256 11.0303 5.46967C10.7374 5.17678 10.2626 5.17678 9.96967 5.46967L8 7.43934L6.03033 5.46967Z"
																	fill="currentColor" />
															</svg>
														</b-button>
													</b-input-group>
												</div>
												<b-tab title="Livestreams" active>
													<div class="text-center text-s-s text-dark-7 mt-3 mb-1" v-if="allInOneStreams.length === 0">
														Please create an All in One stream.
													</div>
													<b-list-group v-else class="stream-source-list mt-2">
														<b-list-group-item button variant="dark-3" v-for="(item, index) in  allInOneStreamsFiltered"
															:key="index" @click="setDestination(item)"
															class="d-flex align-items-center text-dark-8 px-3 py-2 text-s-s text-truncate flex-shrink-0">
															<svg class="mr-2 flex-shrink-0" width="16" height="12" viewBox="0 0 16 12" fill="none"
																xmlns="http://www.w3.org/2000/svg">
																<path fill-rule="evenodd" clip-rule="evenodd"
																	d="M4.9999 0.399902H4.97411C4.29592 0.399897 3.75045 0.399892 3.30905 0.435956C2.85506 0.473048 2.4586 0.55126 2.09253 0.737783C1.50923 1.03499 1.03499 1.50923 0.737783 2.09253C0.55126 2.4586 0.473048 2.85506 0.435956 3.30905C0.399892 3.75045 0.399897 4.29592 0.399902 4.97411V4.9999V6.9999V7.0257C0.399897 7.70388 0.399892 8.24936 0.435956 8.69076C0.473048 9.14474 0.55126 9.5412 0.737783 9.90727C1.03499 10.4906 1.50923 10.9648 2.09253 11.262C2.4586 11.4485 2.85506 11.5268 3.30905 11.5638C3.75045 11.5999 4.29593 11.5999 4.97411 11.5999H4.97412H4.9999H6.9999H7.02568H7.02569C7.70388 11.5999 8.24936 11.5999 8.69076 11.5638C9.14474 11.5268 9.5412 11.4485 9.90727 11.262C10.4906 10.9648 10.9648 10.4906 11.262 9.90727C11.4485 9.5412 11.5268 9.14474 11.5638 8.69076C11.579 8.50555 11.5878 8.30202 11.5929 8.07805L13.9169 9.53058C14.6496 9.98849 15.5999 9.46176 15.5999 8.59778V3.40203C15.5999 2.53805 14.6496 2.01132 13.9169 2.46923L11.5929 3.92176C11.5878 3.69779 11.579 3.49426 11.5638 3.30905C11.5268 2.85506 11.4485 2.4586 11.262 2.09253C10.9648 1.50923 10.4906 1.03499 9.90727 0.737783C9.5412 0.55126 9.14474 0.473048 8.69076 0.435956C8.24936 0.399892 7.70388 0.399897 7.0257 0.399902H6.9999H4.9999ZM11.5999 5.33245V6.66735L14.3999 8.41735V3.58245L11.5999 5.33245ZM10.3999 5.27703V4.9999C10.3999 4.28994 10.3994 3.79355 10.3678 3.40677C10.3368 3.02699 10.2788 2.80603 10.1928 2.63732C10.0107 2.27981 9.71999 1.98915 9.36248 1.80699C9.19378 1.72103 8.97281 1.663 8.59304 1.63197C8.20626 1.60037 7.70987 1.5999 6.9999 1.5999H4.9999C4.28994 1.5999 3.79355 1.60037 3.40677 1.63197C3.02699 1.663 2.80603 1.72103 2.63732 1.80699C2.27981 1.98915 1.98915 2.27981 1.80699 2.63732C1.72103 2.80603 1.663 3.02699 1.63197 3.40677C1.60037 3.79355 1.5999 4.28994 1.5999 4.9999V6.9999C1.5999 7.70987 1.60037 8.20626 1.63197 8.59304C1.663 8.97281 1.72103 9.19378 1.80699 9.36248C1.98915 9.71999 2.27981 10.0107 2.63732 10.1928C2.80603 10.2788 3.02699 10.3368 3.40677 10.3678C3.79355 10.3994 4.28994 10.3999 4.9999 10.3999H6.9999C7.70987 10.3999 8.20626 10.3994 8.59304 10.3678C8.97281 10.3368 9.19378 10.2788 9.36248 10.1928C9.71999 10.0107 10.0107 9.71999 10.1928 9.36248C10.2788 9.19378 10.3368 8.97281 10.3678 8.59304C10.3994 8.20626 10.3999 7.70987 10.3999 6.9999V6.72278V5.27703Z"
																	fill="currentColor" />
															</svg>
															<span class="d-block text-truncate">{{ item.name }}</span>
														</b-list-group-item>
													</b-list-group>
												</b-tab>
											</b-tabs>
										</b-dropdown-text>
									</b-dropdown>

										<b-form-checkbox v-if="destinationStream" @change="destinationStreamToggle"
											v-model="streamToggleStatus" :disabled="toggleProcessing" class="backup_switch ml-10"
											:class="{ 'inactive': streamToggleStatus, 'active': !streamToggleStatus, 'disabled': streamToggleStatus }"
											switch>
										</b-form-checkbox>
								</div>

								<div v-if="destinationAlive" class="text-success text-s-s mt-2 flex items-center tr-status">
									<svg class="mr-1 mt-n1" width="14" height="15" viewBox="0 0 14 15" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd"
											d="M7 14.5C10.866 14.5 14 11.366 14 7.5C14 3.63401 10.866 0.5 7 0.5C3.13401 0.5 0 3.63401 0 7.5C0 11.366 3.13401 14.5 7 14.5ZM11.0303 6.03033C11.3232 5.73744 11.3232 5.26256 11.0303 4.96967C10.7374 4.67678 10.2626 4.67678 9.96967 4.96967L6 8.93934L4.03033 6.96967C3.73744 6.67678 3.26256 6.67678 2.96967 6.96967C2.67678 7.26256 2.67678 7.73744 2.96967 8.03033L5.46967 10.5303C5.76256 10.8232 6.23744 10.8232 6.53033 10.5303L11.0303 6.03033Z"
											fill="currentColor" />
									</svg>
									<span class="d-none d-md-inline">Connected</span>
								</div>


							</div>
						</div>

					</b-col>
				</b-row>
			</b-col>
		</b-row>

		<confirm-modal message="Would you like to delete this transcoder profile ?" modal-id="delete-transcoder"
			modal-type="danger" @modal-confirm="onTranscoderDeleteConfirm" />

		<toggle-stream-modal v-if="transcoder" :stream="transcoder" @modal-toggle="onTranscoderToggleConfirm"
			:transcoderView="true"  @toggle-done="onToggleDone" />

		<demo-video-modal videoid="0MPTCZa5OJIYRebzIe6pY" />
	</b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import TranscoderService from '@/services/TranscoderService'
import StreamStatsService from '@/services/StreamStatsService'
import Spinner from "@/components/ui/Spinner.vue"
import ConfirmModal from '@/components/modals/ConfirmModal.vue'
import StreamPreviewPane from '@/views/StreamsDash/StreamPreviewPane.vue'
import ToggleStreamModal from '@/components/modals/ToggleStreamModal.vue'
import DemoVideoModal from '@/components/modals/DemoVideoModal.vue';

export default {
	name: 'TranscoderManage',
	components: {
		Spinner,
		ConfirmModal,
		StreamPreviewPane,
		ToggleStreamModal,
		DemoVideoModal
	},
	data() {
		return {
			destination: null,
			transcoder: null,
			transcoderWrapp: null,
			selectedCodec: null,
			codecs: [
				{
					name: 'H264'
				},
				// {
				// 	name: 'H265/HEVC'
				// }
			],
			selectedResolution: '1920_1080',
			resolutionOpts: [
				{ text: "1920x1080", value: "1920_1080" },
				{ text: "1280x720", value: "1280_720" },
				{ text: "Custom", value: "custom" },
			],
			selectedFps: null,
			fpsOpts: [
				{
					name: 24,
				},
				{
					name: 25,
				},
				{
					name: 30,
				},
				{
					name: 50
				},
				{
					name: 60
				}
			],
			selectedAudioTrack: 1,
			audioTracks: [
				{ name: 1 },
				{ name: 2 },
				{ name: 3 },
				{ name: 4 },
				{ name: 5 },
				{ name: 6 },
				{ name: 7 },
				{ name: 8 },
				{ name: 9 },
				{ name: 10 },
			],
			copyVideo: true,
			copyAudio: true,
			width: 0,
			height: 0,
			videoBitrate: null,
			audioBitrate: null,
			volume: 1,
			search: '',
			loading: false,
			mediaPulse: null,
			scopeAlive: true,
			streamPreviewSpecsUrl: null,
			streamPreviewSpecsType: null,
			mediaPulseTimeoutCtrl: null,
			allowEditTitle: false,
			dividerPosition: 25,
			saveProcessing: false,
			saveDisabled: true,
			streamAlive: false,

			destinationMediaPulse: null,
			destinationAlive: false,
			destiantionMediaPulseTimeoutCtrl: null,

			bypassFormWatchEvent: false,

			formError: false,
			formErrors: {
				'videoBitrate': { error: null, show: true },
				'width': { error: null, show: true },
				'height': { error: null, show: true },
				'selectedCodec': { error: null, show: true },
				'selectedFps': { error: null, show: true },
				'audioBitrate': { error: null, show: true },
				'volume': { error: null, show: true },
				'selectedAudioTrack': { error: null, show: true }
			},

			streamToggleStatus: null,
			toggleProcessing: false,

			deinterlace: false,
			interlace: false,
			audioTrackEnabled: false
		};
	},
	computed: {
		...mapGetters({
			loadingStatus: "Ui/loadingStatus",
			allInOneStreams: "Streams/allInOneStreams",
			hasLiveSubscription: "User/hasLiveSubscription",
			transcoderFlag: "User/transcoderFlag"
		}),
		allInOneStreamsFiltered() {
			const allInOneStreams = _.cloneDeep(this.allInOneStreams.filter(stream => stream.name.toLowerCase().includes(this.search.toLowerCase()) && stream.enabled))
			return allInOneStreams.sort(function (a, b) {
				return new Date(b.creationTime) - new Date(a.creationTime)
			})
		},
		destinationStream() {
			if (this.transcoder && this.destination) {
				return this.allInOneStreams.find(stream => stream._id === this?.destination?._id)
			}
			return
		},
	},
	watch: {
		// compose into 1 generic function
		copyVideo: {
			handler(after, before) {
				this.formFieldValidateValue('copyVideo', 'copyVideo', after)
			}
		},
		selectedCodec: {
			handler(after, before) {
				this.formFieldValidateValue('selectedCodec', 'codec', after)
			}
		},
		selectedResolution: {
			handler(after, before) {
				this.formFieldValidateValue('selectedResolution', 'resolution', after)
			}
		},
		videoBitrate: {
			handler(after, before) {
				this.formFieldValidateValue('videoBitrate', 'videoBitrate', after)
			}
		},
		selectedFps: {
			handler(after, before) {
				this.formFieldValidateValue('selectedFps', 'fps', after)
			}
		},
		copyAudio: {
			handler(after, before) {
				this.formFieldValidateValue('copyAudio', 'copyAudio', after)
			}
		},
		audioBitrate: {
			handler(after, before) {
				this.formFieldValidateValue('audioBitrate', 'audioBitrate', after)
			}
		},
		volume: {
			handler(after, before) {
				this.formFieldValidateValue('volume', 'volume', after)
			}
		},
		width: {
			handler(after, before) {
				this.formFieldValidateValue('width', 'width', after)
			}
		},
		height: {
			handler(after, before) {
				this.formFieldValidateValue('height', 'height', after)
			}
		},
		deinterlace: {
			handler(after, before) {
				if (this.bypassFormWatchEvent) {
					this.bypassFormWatchEvent = false
					return
				}
				if(after && this.interlace) {
					setTimeout(() => {
						this.bypassFormWatchEvent = true
						this.interlace = false
					}, 10);
				}
				this.formFieldValidateValue('deinterlace', 'deinterlace', after)
			}
		},
		interlace: {
			handler(after, before) {
				if (this.bypassFormWatchEvent) {
					this.bypassFormWatchEvent = false
					return
				}

				if(after && this.deinterlace) {
					setTimeout(() => {
						this.bypassFormWatchEvent = true
						this.deinterlace = false
					}, 10);
				}
				this.formFieldValidateValue('interlace', 'interlace', after)
			}
		},
		selectedAudioTrack: {
			handler(after, before) {
				this.formFieldValidateValue('selectedAudioTrack', 'audioTrack', after)
			}
		},
		audioTrackEnabled: {
			handler(after, before) {
				this.formFieldValidateValue('audioTrackEnabled', 'audioTrackEnabled', after)
			}
		},
		async sourceLiveStream() {
			if (this.sourceLiveStream) {
				await this.unsubscribeMediaPulse()
				await this.subscribeMediaPulse()
			}
		},
		async mediaPulse() {
			this.onMediaPulseChanged();
		},
	},
	async mounted() {
		this.$store.dispatch('Ui/setLoadingStatus', true)
		await this.$store.dispatch('Transcoders/getTranscoder', this.$route && this.$route.params.transcoderId)
		await this.$store.dispatch('Streams/getStreams')
		this.transcoder = _.cloneDeep(this.$store.state.Transcoders.transcoder)
		this.destination = this.transcoder.destination
		this.transcoderWrapp = { hostname: 'n/a', uiRegion: this.transcoder?.region ?? {}, ...this.transcoder, type: 'live' }

		this.defaultSettings()
		this.subscribeMediaPulse()
		this.subscribeMediaPulseDestination()

		this.streamToggleStatus = this.transcoder.destinationEnabled ?? false

		if (!this.destinationStream) {
			this.streamToggleStatus = false
		}
		// TODO Migration artifact - delete after fonal test This changes moved to storage and binding right after api call function
		// const deinterlace = _.get(this.transcoder, ['metadata', 'deinterlace'], false)

		// if (this.transcoder.metadata) {
		// 	this.transcoder.metadata.deinterlace = deinterlace
		// }

		const interlace = _.get(this.transcoder, ['metadata', 'interlace'], false)
		if (this.transcoder.metadata) {
			this.transcoder.metadata.interlace = interlace
		}

		const audioTrackEnabled = _.get(this.transcoder, ['metadata', 'audioTrackEnabled'], false)
		if (this.transcoder.metadata) {
			this.transcoder.metadata.audioTrackEnabled = audioTrackEnabled
		}

		this.$store.dispatch('Ui/setLoadingStatus', false)
	},
	destroyed() {
		this.scopeAlive = false
		this.unsubscribeMediaPulse()
		this.destinationUnsubscribeMediaPulse()

	},
	methods: {
		navigateUpgrade() {
			window.location.href = '/app/subscribe'
		},
		onTranscoderUpdate(newRegion) {
			this.transcoderWrapp.uiRegion = newRegion.uiRegion
		},
		async destinationStreamToggle() {
			if (this.destinationStream) {
				const oldStatus = !this.streamToggleStatus
				this.toggleProcessing = true
				try {
					await TranscoderService.updateTranscoder(this.transcoder._id, { destinationEnabled: this.streamToggleStatus })

					if (this.streamToggleStatus) {
						this.destinationUnsubscribeMediaPulse()
						this.subscribeMediaPulseDestination()
					} else {
						this.destinationUnsubscribeMediaPulse()
						this.destiantionMediaPulse = null
						this.destinationAlive = false
					}

					this.$notify({
						group: "success",
						text: `Stream ${this.destinationStream.name} ${!oldStatus ? 'enabled' : 'disabled'}`
					});
				} catch (err) {
					this.streamToggleStatus = oldStatus
					this.$notify({
						group: 'error',
						title: "Couldn't toggle stream status",
						text: err.message
					});

					if (err.message && err.message.indexOf('upgrade') > -1) {
						this.$root.$emit('bv::show::modal', 'billing-prompt');
					}
				}
				this.toggleProcessing = false
			}
		},
		formFieldValidateValue(formField, metaField, formValue) {
			if (this.bypassFormWatchEvent) {
				return
			}

			let metaValue = this.transcoder.metadata[metaField]
			if (formValue === metaValue) {
				this.saveDisabled = true
				return
			}

			const videoRequiredFields = ['selectedCodec', 'videoBitrate', 'selectedFps']

			const validationLambda = () => {
				if (!this.copyVideo) {
					_.map(videoRequiredFields, (item) => {
						if (!this.$data[item]) {
							this.formErrors[item] = { error: 'required', show: false }
							this.saveDisabled = true
							return
						} else {
							this.formErrors[item] = { error: null, show: true }
						}
					})

					if (this.videoBitrate) {
						if (!this.isNumeric(this.videoBitrate)) {
							this.formErrors.videoBitrate = { error: 'Only numeric value allowed', show: true }
							this.saveDisabled = true
							return
						} else {
							this.formErrors.videoBitrate = { error: null, show: true }
						}

						if (Number(this.videoBitrate) > 15000 || Number(this.videoBitrate) < 250) {
							this.formErrors.videoBitrate = { error: 'Bitrate value should be from 250 to 15000', show: true }
							this.saveDisabled = true
							return
						} else {
							this.formErrors.videoBitrate = { error: null, show: true }
						}
					}

					if (this.selectedResolution === 'custom') {
						const width = this.width
						const height = this.height

						if (!width) {
							this.formErrors.width = { error: 'required', show: false }
							this.saveDisabled = true
							return
						} else {
							this.formErrors.width = { error: null, show: false }
						}

						if (!this.isNumeric(width)) {
							this.formErrors.width = { error: 'Only numeric value allowed', show: true }
							this.saveDisabled = true
							return
						} else {
							this.formErrors.width = { error: null, show: false }
						}

						if (Number(width) > 3840 || Number(width) < 320) {
							this.formErrors.width = { error: 'Allowed range from 320 to 3840', show: true }
							this.saveDisabled = true
							return
						} else {
							this.formErrors.width = { error: null, show: true }
						}

						if (!height) {
							this.formErrors.height = { error: 'required', show: false }
							this.saveDisabled = true
							return
						} else {
							this.formErrors.height = { error: null, show: false }
						}

						if (!this.isNumeric(height)) {
							this.formErrors.height = { error: 'Only numeric value allowed', show: true }
							this.saveDisabled = true
							return
						} else {
							this.formErrors.height = { error: null, show: false }
						}

						if (Number(height) > 2160 || Number(height) < 240) {
							this.formErrors.height = { error: 'Allowed range from 240 to 2160', show: true }
							this.saveDisabled = true
							return
						} else {
							this.formErrors.height = { error: null, show: true }
						}

					} else {
						this.formErrors.width = { error: null, show: false }
						this.formErrors.height = { error: null, show: false }
					}
				} else {
					this.formErrors.videoBitrate = { error: null, show: true }
					this.formErrors.width = { error: null, show: true }
					this.formErrors.height = { error: null, show: true }
					this.formErrors.selectedCodec = { error: null, show: true }
					this.formErrors.selectedFps = { error: null, show: true }
				}

				const audioRequiredFields = ['audioBitrate', 'volume']

				if (!this.copyAudio) {
					_.map(audioRequiredFields, (item) => {
						if (!this.$data[item]) {
							this.formErrors[item] = { error: 'required', show: false }
							this.saveDisabled = true
							return
						} else {
							this.formErrors[item] = { error: null, show: true }
						}
					})

					if (this.audioBitrate) {
						if (!this.isNumeric(this.audioBitrate)) {
							this.formErrors.audioBitrate = { error: 'Only numeric value allowed', show: true }
							this.saveDisabled = true
							return
						} else {
							this.formErrors.audioBitrate = { error: null, show: true }
						}

						if (Number(this.audioBitrate) > 320 || Number(this.audioBitrate) < 32) {
							this.formErrors.audioBitrate = { error: 'Allowed range from 32 to 320', show: true }
							this.saveDisabled = true
							return
						} else {
							this.formErrors.audioBitrate = { error: null, show: true }
						}
					}

					if (this.volume) {
						if (!this.isNumeric(this.volume)) {
							this.formErrors.volume = { error: 'Only numeric value allowed', show: true }
							this.saveDisabled = true
							return
						} else {
							this.formErrors.volume = { error: null, show: true }
						}

						if (Number(this.volume) > 2 || Number(this.volume) < 0) {
							this.formErrors.volume = { error: 'Allowed range from 0 to 2', show: true }
							this.saveDisabled = true
							return
						} else {
							this.formErrors.volume = { error: null, show: true }
						}
					}

				} else {
					this.formErrors.audioBitrate = { error: null, show: true }
					this.formErrors.volume = { error: null, show: true }
					this.formErrors.selectedAudioTrack = { error: null, show: true }
				}
			}

			validationLambda()

			let disabled = false
			// check other errors: if any errors block button
			_.map(Object.values(this.formErrors), (val, n) => {
				if (val.error) {
					disabled = true
				}
			})

			if (!disabled) {
				this.saveDisabled = false
			}

			return
		},

		formFieldValueTypeCheck(formField, value) {
		},
		isNumeric(str) {
			if (typeof str === 'number') return true
			if (typeof str != "string") return false
			return !isNaN(str) && !isNaN(parseFloat(str))
		},
		onTranscoderToggle(transcoder) {
			this.$root.$emit('bv::show::modal', 'modalToggleStream' + this.transcoder._id)
		},
		onTranscoderToggleConfirm() {
		},
		async onToggleDone(){
					await this.$store.dispatch('Transcoders/getTranscoder', this.$route && this.$route.params.transcoderId)
		await this.$store.dispatch('Streams/getStreams')
		this.transcoder = _.cloneDeep(this.$store.state.Transcoders.transcoder)
		this.destination = this.transcoder.destination
		this.transcoderWrapp = { hostname: 'n/a', uiRegion: this.transcoder?.region ?? {}, ...this.transcoder, type: 'live' }

		},
		onTranscoderDelete(transcoder) {
			this.$root.$emit('bv::show::modal', 'delete-transcoder')
		},
		async onTranscoderDeleteConfirm() {
			try {
				await TranscoderService.deleteTranscoder(this.transcoder._id)
				await this.$store.dispatch('Transcoders/getTranscoders')
				this.$notify({
					group: 'success',
					text: 'Transcoder profile deleted'
				})

				setTimeout(() => {
					this.$router.push({
						name: 'TranscoderDashboard',
					})
				}, 300)

				return
			} catch (err) {
				console.error(err)
				this.$notify({
					group: 'error',
					text: 'Delete transcoder profile failed'
				});
			}
		},
		onResolutionSelect() { },
		onFpsSelect(fps) {
			this.selectedFps = fps.name
		},
		onAudioTrackSelect(track) {
			this.selectedAudioTrack = track.name
		},
		onCodecSelect(codec) {
			this.selectedCodec = codec.name
		},
		async saveSettings() {
			this.saveProcessing = true

			const data = {
				copyVideo: this.copyVideo,
				copyAudio: this.copyAudio,
				codec: this.selectedCodec,
				fps: this.selectedFps,
				resolution: this.selectedResolution,
				width: this.width,
				height: this.height,
				videoBitrate: this.videoBitrate,
				audioBitrate: this.audioBitrate,
				volume: this.volume,
				deinterlace: this.deinterlace,
				interlace: this.interlace,
				audioTrack: this.selectedAudioTrack,
				audioTrackEnabled: this.audioTrackEnabled,
			}
			try {
				await TranscoderService.setTranscoderSettings(
					this.transcoder._id,
					data
				)

				// TODO: rewrite with manual push to vuex
				await this.$store.dispatch('Transcoders/getTranscoder', this.$route && this.$route.params.transcoderId)
				await this.$store.dispatch('Transcoders/getTranscoders')

				this.transcoder = this.$store.state.Transcoders.transcoder
				this.destination = this.transcoder.destination
				this.bypassFormWatchEvent = true
				this.defaultSettings()
				this.bypassFormWatchEvent = false
				this.saveDisabled = true

				this.$notify({
					group: 'success',
					text: 'Transcoder settings saved',
				})
			} catch (err) {
				console.log(err)
				this.$notify({
					group: 'error',
					title: 'Set transcoder settings failed',
					text: err.message || 'update settings failed'
				});
			}
			this.saveProcessing = false
		},
		defaultSettings() {
			if (this.transcoder.metadata) {
				this.copyVideo = this.transcoder.metadata.copyVideo
				this.copyAudio = this.transcoder.metadata.copyAudio
				this.selectedCodec = this.transcoder.metadata.codec
				this.selectedFps = this.transcoder.metadata.fps
				this.selectedResolution = this.transcoder.metadata.resolution || '1920_1080'
				this.width = this.transcoder.metadata.width
				this.height = this.transcoder.metadata.height
				this.videoBitrate = this.transcoder.metadata.videoBitrate
				this.audioBitrate = this.transcoder.metadata.audioBitrate
				this.volume = this.transcoder.metadata.volume || 1
				this.deinterlace = this.transcoder.metadata.deinterlace || false
				this.interlace = this.transcoder.metadata.interlace || false
				this.selectedAudioTrack =  this.transcoder.metadata.audioTrack || 1
				this.audioTrackEnabled = this.transcoder.metadata.audioTrackEnabled || false
			}
		},
		cancelSettings() {
			this.defaultSettings()
		},
		async setDestination(item) {
			try {
				const data = { destination: item ? item._id : item }
				await TranscoderService.updateTranscoder(
					this.transcoder._id,
					data
				)

				this.destination = item
				this.streamToggleStatus = item ? item.enabled : false

				if (this.destination) {
					this.destinationUnsubscribeMediaPulse()
					this.subscribeMediaPulseDestination()
				} else {
					this.destinationUnsubscribeMediaPulse()
					this.destiantionMediaPulse = null
					this.destinationAlive = false
				}

				setTimeout(() => {
					this.$refs.source.hide(true)
				}, 150)
				this.$notify({
					group: 'success',
					text: `Destination updated`,
				})

				// TODO: rewrite with manual push to vuex
				await this.$store.dispatch('Transcoders/getTranscoder', this.$route && this.$route.params.transcoderId)
				await this.$store.dispatch('Transcoders/getTranscoders');
			} catch (err) {
				console.log(err)
				setTimeout(() => {
					this.$refs.source.hide(true)
				}, 150)
				this.$notify({ group: 'error', text: err.message || 'Destination update failed' });
			}
		},
		subscribeMediaPulseDestination() {
			const streamKey = this?.destination?.key
			const streamEnabled = true
			const self = this;
			(async function loop() {
				if (!self.scopeAlive) return

				if (!streamKey) return

				let timeoutInterval = 5000
				let shouldUpdatePulse = streamEnabled
				if (document.hidden) {
					shouldUpdatePulse = false
					timeoutInterval = 6000
				}

				if (shouldUpdatePulse) {
					if (!document.hasFocus()) {
						timeoutInterval = 14000
					}
				}
				if (shouldUpdatePulse) {
					try {
						const pulseObject = await StreamStatsService.getStreamMediaPulse(
							streamKey
						)
						self.onMediaPulseDestination(pulseObject);
					} catch (e) { }
				} else self.destinationMediaPulse = null
				self.destiantionMediaPulseTimeoutCtrl = setTimeout(loop, timeoutInterval);
			})();
		},
		onMediaPulseDestination(pulseObject = {}) {
			if (this.destiantionMediaPulse && this.destiantionMediaPulse.withoutPushStats) {
				const oldPushStats = this.destinationMediaPulse.push_stats;
				pulseObject.push_stats = oldPushStats;
			}
			this.destinationMediaPulse = pulseObject;
			this.destinationAlive =
				this.transcoder.destination.enabled && this.destinationMediaPulse && this.destinationMediaPulse.alive;
		},

		subscribeMediaPulse() {
			const streamKey = this.transcoder.key
			const streamEnabled = true
			const self = this;
			(async function loop() {
				if (!self.scopeAlive) return

				let timeoutInterval = 5000
				let shouldUpdatePulse = streamEnabled
				if (document.hidden) {
					shouldUpdatePulse = false
					timeoutInterval = 6000
				}

				if (shouldUpdatePulse) {
					if (!document.hasFocus()) {
						timeoutInterval = 14000
					}
				}
				if (shouldUpdatePulse) {
					try {
						const pulseObject = await StreamStatsService.getStreamMediaPulse(
							streamKey
						)
						self.onMediaPulse(pulseObject);

						// console.log('mediPulse stream', self.stream)
						if (self.stream.failoverIngest) {
							const backupPulseObject = await StreamStatsService.getStreamMediaPulse(
								`${streamKey}_backup`
							)
							self.onBackupMediaPulse(backupPulseObject)
						}
					} catch (e) { }
				} else self.mediaPulse = null
				// reschedule
				self.mediaPulseTimeoutCtrl = setTimeout(loop, timeoutInterval);
			})();
		},
		onMediaPulse(pulseObject = {}) {
			if (this.mediaPulse && this.mediaPulse.withoutPushStats) {
				const oldPushStats = this.mediaPulse.push_stats;
				pulseObject.push_stats = oldPushStats;
			}
			this.mediaPulse = pulseObject;
			this.streamAlive =
				this.transcoder.enabled && this.mediaPulse && this.mediaPulse.alive;
			this.streamFps = this.mediaPulse.fps;
		},
		async onMediaPulseChanged() {
			if (this.mediaPulse && this.mediaPulse?.isWowza === true) {
				this.streamPreviewSpecsType = 'hls';
				this.streamPreviewSpecsUrl = `https://wowza-stage.castr.io/static/${this.sourceLiveStream.key}/playlist_sfm4s.m3u8`;
			}

			if (_.isEmpty(this.streamPreviewSpecs) && this.sourceLiveStream && this.sourceLiveStream.key) {
				this.streamPreviewSpecsType = 'mse';
				this.streamPreviewSpecsUrl = `wss://wowza-stage.castr.io/${this.sourceLiveStream.key}/mse_ld?tracks=v1a1`;
			}
		},
		unsubscribeMediaPulse() {
			clearTimeout(this.mediaPulseTimeoutCtrl);
		},
		destinationUnsubscribeMediaPulse() {
			clearTimeout(this.destiantionMediaPulseTimeoutCtrl);
		},
		editTranscoderName(e) {
			this.allowEditTitle = true
			setTimeout(() => {
				this.$refs.title.focus()
			}, 100);
		},
		async saveNewTranscoderName(e) {
			e.preventDefault();
			e.stopPropagation();
			const newName = e.target.innerText
			if (newName != this.transcoder.name) {
				const data = { name: newName }
				await TranscoderService.updateTranscoder(
					this.transcoder._id,
					data
				)

				this.allowEditTitle = false
				this.$notify({ group: 'info', text: 'Transcoder was renamed' })
			}
		},
		showDeleteModal() {
			this.$root.$emit("bv::show::modal", 'delete-transcoder');
		},
		handleDragging(e) {
			e.preventDefault();
			const position = e.pageX
			const wrapper = document.getElementById('resizible-wrapper')
			const windowWidth = window.innerWidth
			const percentage = ((position - 260) / wrapper.offsetWidth) * 100
			if (percentage >= 20 && percentage <= 30) {
				this.dividerPosition = percentage.toFixed(2)
			}
			if (position - 260 <= 0) {
				document.removeEventListener('mousemove', this.handleDragging)
			}
		},
		startDragging() {
			document.addEventListener('mousemove', this.handleDragging)
		},
		endDragging() {
			document.removeEventListener('mousemove', this.handleDragging)
		}
	},
}

</script>

<style>
.custom-control.custom-radio {
	margin-right: 1em;
}
</style>

<style scoped>
.w-80 {
	width: 80%;
}

.phone-number-section {
	border: 1px solid #dee2e6;
	border-color: var(--c-dark-3);
	border-radius: 12px;
}

.aside-secondary {
	max-height: 100vh;
	height: 93vh;
	width: 400px;
	margin-bottom: -65px;
	border-right: 1px solid var(--c-dark-2);
	padding: 0 1rem;
	position: relative;
}

.transcoder-settings-container {
	border-radius: 6px;
	padding: 20px;
}

.title {
	padding: .25rem .5rem;
	margin: 0 -.5rem;
	transition: .3s;
	word-break: break-all;
}

.title:hover {
	background-color: var(--c-dark-2);
	transition: .3s;
}

.title-editable {
	background-color: var(--c-dark-2);
	outline: none;
	box-shadow: 0 0 2px rgba(0, 0, 0, .3);
}

:deep(.stream-source-menu) {
	width: 22rem;
	border-radius: 6px;
}

:deep(.b-dropdown.show>.stream-source-menu) {
	z-index: 1040;
}

.stream-source-list {
	max-height: 22rem;
	overflow-y: auto;
}

.stream-source-list .list-group-item-action:hover,
.stream-source-list .list-group-item-action:focus {
	background-color: var(--c-dark-4);
	color: #fff;
	outline: none;
}

:deep(.tabs-light-border) {
	border-bottom: 1px solid var(--c-dark-4);
}

.mw-vod {
	max-width: 80%;
}

.select-arrow {
	position: absolute;
	right: 3rem;
	top: 3.5rem;
}

@media (max-width: 767px) {
	.video-placeholder {
		margin: 0 -15px;
	}
	.aside-secondary--transcoder{
		border-right: 0px;
		width: calc(100%);
		height: unset;
		margin-bottom: 0;
	}
	.heading-transcoder--settings {
    background: var(--c-dark-2);
    padding: 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.transcoder-settings-container {
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
    padding-top: 0px !important;
}

.heading-transcoder--settings>div:last-child {
    border-bottom: 1px solid var(--c-dark-3);
    margin-bottom: 0 !important;
}
.tr-status {
    position: absolute;
    right: -11px;
    bottom: 7px;
}
}

@media (min-width: 768px) {
	.video-placeholder {
		border-radius: .5rem;
	}
	.text-md-s-xxll{
		font-size: 24px;
	}
	.overflow-md-visible {
		overflow: visible !important;
	}
}
</style>
